// Event
import systemCartRequest from './event/systemCartRequest.js';
import systemError from './event/systemError.js';
import systemHint from './event/systemHint.js';
import systemActivation from './event/systemActivation.js';
import systemOrder from './event/systemOrder.js';
import systemServiceInfo from './event/systemServiceInfo.js';
import userAddProducts from './event/userAddProducts.js';
import userClick from './event/userClick.js';
import userHint from './event/userHint.js';
import userRemoveProducts from './event/userRemoveProducts.js';
import userUpdateOrder from './event/userUpdateOrder.js';

// Screen
import billingInfo from './screen/billingInfo.js';
import companyInfo from './screen/companyInfo.js';
import crossPop from './screen/crossPop.js';
import errorPage from './screen/errorPage.js';
import reviewPage from './screen/reviewPage.js';
import thankyouPage from './screen/thankyouPage.js';

// Shared
import hint from './shared/hint.js';
import initScreen from './shared/initScreen.js';
import order from './shared/order.js';
import product from './shared/product.js';
import productList from './shared/productList.js';
import screen from './shared/screen.js';

export default {
	systemActivation,
	systemCartRequest,
	systemError,
	systemHint,
	systemOrder,
	systemServiceInfo,
	userAddProducts,
	userClick,
	userHint,
	userRemoveProducts,
	userUpdateOrder,
	billingInfo,
	companyInfo,
	crossPop,
	errorPage,
	reviewPage,
	thankyouPage,
	hint,
	initScreen,
	order,
	product,
	productList,
	screen
};
